import React, {Fragment, Dispatch} from 'react';
import {Button} from 'reactstrap';
import {setStepVisible, addStep} from '../../reducer/config-reducer';
import {connect} from 'react-redux';

interface configObject {
  configReducer: {
    steps: Array<string>;
  };
}
interface propiedadesBackStepButton {
  setStepVisible: Dispatch<string>;
  addStep: Dispatch<string>;
  steps: Array<string>;
  label: string;
}

const BackStepButton = (props: propiedadesBackStepButton) => {
  const buttonEvent = () => {
    const totaldePasos: number = props.steps.length;
    props.setStepVisible(props.steps[totaldePasos - 2]);
    props.addStep(props.steps[totaldePasos - 2]);
  };

  return (
    <Fragment>
      {props.steps.length > 1 &&
        props.steps[props.steps.length - 2] !==
          props.steps[props.steps.length - 1] && (
          <Button onClick={buttonEvent} color="secondary" className="border-0">
            {props.label}
          </Button>
        )}
    </Fragment>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    steps: state.configReducer.steps,
  };
};

export default connect(mapStateToProps, {setStepVisible, addStep})(
  BackStepButton,
);
